<template>
    <div>
        <a :class="{active: liked, 'text-body': !liked}" href="javascript:void(0)" class="d-flex align-items-center leading-none" v-on:click="toggleLike">
            <i class="fa fa-thumbs-up small mr-1"></i> <span>Like</span>
        </a>
    </div>
</template>

<script>

export default {
    props: {
        post: {
            type: Object
        },
        postLikes: {
            type: Array,
            default() {
                return [];
            }
        },
        user: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            likesToolTipOpen: false
        }
    },
    methods: {
        toggleLike() {
            this.$emit('postLikeToggled', this.post.id);
        }
    },
    computed: {
        liked() {
            return this.postLikes.filter(like => like.employee_id === this.user.employee_id).length > 0;
        },
        likeList() {
            return this.postLikes.filter((like, index) => (index + 1) <= 10);
        },
        likesNotShownCount() {
            return this.postLikes.length - this.likeList.length;
        }
    }
}
</script>

<style scoped>
    .active {
        color: #022A8A;
    }
</style>
